/**
 * live/event-labels.ts — come si chiama un evento del live in italiano.
 *
 * Un solo elenco: lo usano la cronaca pubblica, la console dell'area riservata
 * e i messaggi dell'annullamento. (Prima era copiato identico in due componenti:
 * aggiungere un tipo di evento significava ricordarsene in tre posti.)
 */
export const LIVE_EVENT_LABEL: Record<string, string> = {
  point: 'Punto',
  ace: 'Ace',
  attack: 'Attacco',
  block: 'Muro',
  defense: 'Difesa',
  reception: 'Ricezione',
  opponent_error: 'Errore avversario',
  set_start: 'Inizio set',
  set_end: 'Fine set',
  match_end: 'Fine partita',
  timeout: 'Time-out',
  timeout_home: 'Time-out casa',
  timeout_away: 'Time-out ospite',
  substitution: 'Sostituzione',
  yellow_card: 'Cartellino giallo',
  red_card: 'Cartellino rosso',
  expulsion: 'Espulsione',
  disqualification: 'Squalifica',
  set_service: 'Imposta servizio',
  SET_SERVICE: 'Imposta servizio',
  note: 'Nota',
  status: 'Stato',
  correction: 'Correzione',
  point_scorer: 'Attribuzione punto',
  lineup: 'Formazione',
  manual: 'Manuale',
}

export function liveEventLabel(type: string | null | undefined): string {
  if (!type) return 'Azione'
  return LIVE_EVENT_LABEL[type] ?? type
}
